<template>
    <div :class="{'page-wrapper': themeName !== 'GolfCart'}" id="golf_cart_not_visible">
        <router-view />
        <Toast :breakpoints="{'920px': {width: '100%', right: '0', left: '0'}}" />
        <DialogsWrapper />
    </div>
</template>

<script>
    import MyLayout from '@/layout/layout.vue'
    import AuthUserServices from './Services/AuthUserServices.js';

    export default {
        components: {
            MyLayout
        },
        data() {


            return {
                themeName: '',

            }
        },
        mounted() {
            this.GetDynamicContent();
        },
        created() {
            this.GetDynamicContent();
            // this.ChangeFavIcon();
           
            const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

            const storedTime = localStorage.getItem("initialLandingPageTime");

            if (storedTime) {
                const storedDate = new Date(storedTime);
                const now = new Date();
                if (now - storedDate > ONE_MONTH_MS) {
                    localStorage.removeItem("initialLandingPage");
                    localStorage.removeItem("initialLandingPageTime");
                    localStorage.setItem("initialLandingPage", window.location.href);
                    //const localDateTime =
                    //    now.getFullYear() + '-' +
                    //    String(now.getMonth() + 1).padStart(2, '0') + '-' +
                    //    String(now.getDate()).padStart(2, '0') + ' ' +
                    //    String(now.getHours()).padStart(2, '0') + ':' +
                    //    String(now.getMinutes()).padStart(2, '0') + ':' +
                    //    String(now.getSeconds()).padStart(2, '0');
                    const localDateTime = new Date().toISOString()
                    localStorage.setItem("initialLandingPageTime", localDateTime);
                }
            }
            if (!localStorage.getItem("initialLandingPage")) {
                localStorage.removeItem("initialLandingPage");
                localStorage.removeItem("initialLandingPageTime");
                localStorage.setItem("initialLandingPage", window.location.href);
                //const localDateTime1 =
                //    now.getFullYear() + '-' +
                //    String(now.getMonth() + 1).padStart(2, '0') + '-' +
                //    String(now.getDate()).padStart(2, '0') + ' ' +
                //    String(now.getHours()).padStart(2, '0') + ':' +
                //    String(now.getMinutes()).padStart(2, '0') + ':' +
                //    String(now.getSeconds()).padStart(2, '0');
                const localDateTime = new Date().toISOString()
                localStorage.setItem("initialLandingPageTime", localDateTime);
            }
            this.themeName = localStorage.getItem('theme');



            setTimeout(function () {
                if (this.themeName == 'GolfCart') {
                    var getId = document.getElementById("golf_cart_not_visible")
                    if (getId != null) {
                        getId.classList.remove("page-wrapper");
                    }

                    this.addGoogleTagManager();

                    this.addGoogleTagManagerNoscript();
                }
            }, 4000);
        },
        methods: {
            async addGoogleTagManager() {
                // Create a script tag for GTM
                const script = document.createElement('script');
                script.innerHTML = `(function(w,d,s,l,i){
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-NZ9ZFWFS');`;

                document.head.appendChild(script);

                // Optionally, add a noscript fallback for users who have JavaScript disabled
                const noscript = document.createElement('noscript');
                noscript.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NZ9ZFWFS" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                document.body.appendChild(noscript);
            },
            async addGoogleTagManagerNoscript() {
                const noscript = document.createElement('noscript');
                noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NZ9ZFWFS" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
                document.body.appendChild(noscript);
            },
            async GetDynamicContent() {
                debugger
               await AuthUserServices.GetDynamicContentForComapny(localStorage.getItem("companyId"), localStorage.getItem("userId"), localStorage.getItem("LanguageId")).then(res => {
                    const favicon = document.getElementById("favicon");
                    favicon.href = res.data.favIconLink;
                })
            },
        }

    }
</script>

<style>
</style>
